import { render, staticRenderFns } from "./problemDetailNew.vue?vue&type=template&id=95b2026a"
import script from "./problemDetailNew.vue?vue&type=script&lang=js"
export * from "./problemDetailNew.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports